(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,5587,1482,7377],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(87625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98456);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 11291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HorizontalLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function HorizontalLine(param) {
    let { height ="1px" , width ="100%" , color ="var(--white)" , margin ="0"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            height,
            width,
            backgroundColor: color,
            margin
        }
    });
}


/***/ }),

/***/ 46625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecipeCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27515);
/* harmony import */ var _recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22120);
/* harmony import */ var utils_getImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95785);
/* harmony import */ var remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11327);
/* harmony import */ var remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99954);
/* harmony import */ var remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34349);
/* harmony import */ var redux_slices_currency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64698);
/* harmony import */ var _line_horizontalLine__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11291);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_9__);












function RecipeCard(param) {
    let { data  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const currency = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(redux_slices_currency__WEBPACK_IMPORTED_MODULE_7__/* .selectCurrency */ .j);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/recipes/".concat(data === null || data === void 0 ? void 0 : data.id, "?currency_id=").concat(currency === null || currency === void 0 ? void 0 : currency.id),
        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().header),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                    fill: true,
                    src: (0,utils_getImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data === null || data === void 0 ? void 0 : data.img),
                    alt: (data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title) || "Recipe Image",
                    sizes: "400px",
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().body),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().main),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                                children: (data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title) || t("N/A")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_line_horizontalLine__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                color: "var(--border-color)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
                                children: (data === null || data === void 0 ? void 0 : (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description) || t("N/A")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_line_horizontalLine__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        color: "var(--border-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
                                        children: [
                                            data === null || data === void 0 ? void 0 : data.total_time,
                                            " ",
                                            t("min")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().dot)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_RestaurantFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
                                        children: [
                                            data === null || data === void 0 ? void 0 : data.calories,
                                            " ",
                                            t("kkl")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_recipeCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().shopIcon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                            src: (data === null || data === void 0 ? void 0 : (ref3 = data.shop) === null || ref3 === void 0 ? void 0 : ref3.logo_img) || "",
                            alt: (data === null || data === void 0 ? void 0 : (ref4 = data.shop) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.translation) === null || ref5 === void 0 ? void 0 : ref5.title) || "Shop Logo",
                            // fill
                            width: 50,
                            height: 50
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 84169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5848);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3075);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21697);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 1482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopCategoryList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(9526);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/categoryCard/v1.module.scss
var v1_module = __webpack_require__(5676);
var v1_module_default = /*#__PURE__*/__webpack_require__.n(v1_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/categoryCard/v1.tsx






function CategoryCard(param) {
    let { data  } = param;
    var ref;
    const { query  } = (0,router.useRouter)();
    const handleQuery = (categoryId)=>{
        if (Number(query === null || query === void 0 ? void 0 : query.category_id) === categoryId) {
            return {
                ...query,
                category_id: undefined
            };
        }
        return {
            ...query,
            category_id: categoryId
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            query: handleQuery(data === null || data === void 0 ? void 0 : data.id)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((v1_module_default()).card, " ").concat(Number(query === null || query === void 0 ? void 0 : query.category_id) === (data === null || data === void 0 ? void 0 : data.id) ? (v1_module_default()).active : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 30,
                    height: 30,
                    className: (v1_module_default()).img,
                    alt: "Category icon",
                    src: (data === null || data === void 0 ? void 0 : data.img) || "",
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (v1_module_default()).text,
                    children: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.module.scss
var shopCategoryList_v1_module = __webpack_require__(12562);
var shopCategoryList_v1_module_default = /*#__PURE__*/__webpack_require__.n(shopCategoryList_v1_module);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
;// CONCATENATED MODULE: ./containers/shopCategoryList/v1.tsx









function ShopCategoryList(param) {
    let { data , loading , parent  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopCategoryList_v1_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (shopCategoryList_v1_module_default()).title,
                children: t("categories")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: !loading && (data === null || data === void 0 ? void 0 : data.length) === 0 ? "none" : "block",
                    background: "var(primary-bg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    className: "full-width",
                    modules: [
                        swiper_esm/* Navigation */.W_,
                        swiper_esm/* Lazy */.oM
                    ],
                    navigation: true,
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    lazy: true,
                    children: [
                        !!parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                maxWidth: "max-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/shop-category/".concat(parent),
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shopCategoryList_v1_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shopCategoryList_v1_module_default()).text,
                                        children: t("all")
                                    })
                                })
                            })
                        }),
                        loading ? Array.from(Array(10).keys()).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    className: (shopCategoryList_v1_module_default()).shimmer
                                })
                            }, item)) : data === null || data === void 0 ? void 0 : data.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCard, {
                                    data: category,
                                    parent: parent
                                })
                            }, category.id))
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 37490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 2950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21697);


function useUserLocation() {
    const { location: userLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    const location = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const latlng = userLocation;
        if (!latlng) {
            return undefined;
        }
        return {
            latitude: latlng.split(",")[0],
            longitude: latlng.split(",")[1]
        };
    }, [
        userLocation
    ]);
    return location;
}


/***/ }),

/***/ 87625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(84169);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var dist_es = __webpack_require__(22120);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(1612);
// EXTERNAL MODULE: ./services/category.ts
var category = __webpack_require__(56457);
// EXTERNAL MODULE: ./services/banner.ts
var banner = __webpack_require__(94910);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(2950);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./containers/homev1/homev1.module.scss
var homev1_module = __webpack_require__(79457);
var homev1_module_default = /*#__PURE__*/__webpack_require__.n(homev1_module);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(29969);
// EXTERNAL MODULE: ./containers/banner/banner.module.scss
var banner_module = __webpack_require__(45286);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/bannerSingle/bannerSingle.module.scss
var bannerSingle_module = __webpack_require__(91893);
var bannerSingle_module_default = /*#__PURE__*/__webpack_require__.n(bannerSingle_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/slug.ts
var utils_slug = __webpack_require__(83047);
;// CONCATENATED MODULE: ./components/bannerSingle/bannerSingle.tsx





function BannerSingle(param) {
    let { data , index  } = param;
    var ref, ref1;
    const isExternal = (data === null || data === void 0 ? void 0 : data.action_type) === "external";
    const isShop = (data === null || data === void 0 ? void 0 : data.action_type) === "shop";
    const isProduct = (data === null || data === void 0 ? void 0 : data.action_type) === "product";
    var ref2;
    // ✅ Next/Image vuole sempre una stringa valida
    const imgSrc = (ref2 = data === null || data === void 0 ? void 0 : data.img) !== null && ref2 !== void 0 ? ref2 : "/placeholder.png";
    // ✅ default (promotion)
    let href = "/promotion/".concat(data === null || data === void 0 ? void 0 : data.id);
    // ✅ shop → /shop/{id}/{compactSlug(title)}
    if (isShop && (data === null || data === void 0 ? void 0 : (ref = data.shops) === null || ref === void 0 ? void 0 : ref.length)) {
        var ref3;
        const shop = data.shops[0];
        const title = (shop === null || shop === void 0 ? void 0 : (ref3 = shop.translation) === null || ref3 === void 0 ? void 0 : ref3.title) || "";
        const slug = (0,utils_slug/* compactSlug */.Z)(title);
        if ((shop === null || shop === void 0 ? void 0 : shop.id) && slug) {
            href = "/shop/".concat(shop.id, "/").concat(slug);
        }
    }
    // ✅ product → /product/{id}/{slugify(title)}
    if (isProduct && (data === null || data === void 0 ? void 0 : data.product)) {
        var ref4;
        const product = data.product;
        const title1 = (product === null || product === void 0 ? void 0 : (ref4 = product.translation) === null || ref4 === void 0 ? void 0 : ref4.title) || (product === null || product === void 0 ? void 0 : product.title) || "";
        const slug1 = (0,utils_slug/* slugify */.l)(title1);
        if ((product === null || product === void 0 ? void 0 : product.id) && slug1) {
            href = "/product/".concat(product.id, "/").concat(slug1);
        }
    }
    const content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (bannerSingle_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            fill: true,
            priority: index === 0,
            loading: index !== 0 ? "lazy" : "eager",
            src: imgSrc,
            alt: (data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title) || "Banner Image",
            quality: 90,
            sizes: "(max-width: 1140px) 1110px, 1500px",
            style: {
                objectFit: "cover",
                objectPosition: "center"
            }
        })
    });
    // ✅ external → link esterno
    if (isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: (data === null || data === void 0 ? void 0 : data.url) || "#",
            target: "_blank",
            rel: "noopener noreferrer",
            className: (bannerSingle_module_default()).banner,
            children: content
        });
    }
    // ✅ promotion + shop + product → Link interno
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        className: (bannerSingle_module_default()).banner,
        children: content
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightSLineIcon.js
var ArrowRightSLineIcon = __webpack_require__(97169);
var ArrowRightSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightSLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowLeftSLineIcon.js
var ArrowLeftSLineIcon = __webpack_require__(71350);
var ArrowLeftSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftSLineIcon);
// EXTERNAL MODULE: ./components/carouselArrows/carouselArrows.module.scss
var carouselArrows_module = __webpack_require__(8341);
var carouselArrows_module_default = /*#__PURE__*/__webpack_require__.n(carouselArrows_module);
;// CONCATENATED MODULE: ./components/carouselArrows/carouselArrows.tsx






function NextButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).next),
        onClick: ()=>swiper.slideNext(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightSLineIcon_default()), {})
    });
}
function PrevButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).prev),
        onClick: ()=>swiper.slidePrev(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftSLineIcon_default()), {})
    });
}


// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(9526);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84601);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
;// CONCATENATED MODULE: ./containers/banner/banner.tsx








function BannerContainer(param) {
    let { banners , loadingBanner  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (banner_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (banner_module_default()).banner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (banner_module_default()).bannerContainer,
                children: !loadingBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 20,
                    slidesPerView: 1,
                    lazy: {
                        enabled: true,
                        loadPrevNext: false,
                        loadPrevNextAmount: 0,
                        loadOnTransitionStart: true
                    },
                    // preloadImages={false}
                    modules: [
                        swiper_esm/* Lazy */.oM
                    ],
                    children: [
                        banners.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSingle, {
                                    data: item,
                                    index: index
                                })
                            }, item.id)),
                        banners.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (banner_module_default()).shimmerContainer,
                    children: Array.from(new Array(1)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (banner_module_default()).shimmer
                        }, "banner" + idx))
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(77262);
// EXTERNAL MODULE: ./node_modules/remixicon-react/MapPinRangeFillIcon.js
var MapPinRangeFillIcon = __webpack_require__(80578);
var MapPinRangeFillIcon_default = /*#__PURE__*/__webpack_require__.n(MapPinRangeFillIcon);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/home-actions/home-actions.module.scss
var home_actions_module = __webpack_require__(44352);
var home_actions_module_default = /*#__PURE__*/__webpack_require__.n(home_actions_module);
;// CONCATENATED MODULE: ./components/home-actions/home-actions.tsx







const HomeFilter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8238).then(__webpack_require__.bind(__webpack_require__, 98238)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98238)
            ]
    }
});
function HomeActions() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const { push  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (home_actions_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFilter, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (home_actions_module_default()).viewInMap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MapPinRangeFillIcon_default()), {
                        size: 20
                    }),
                    fullWidth: false,
                    onClick: ()=>push("/shops-in-map"),
                    rounded: false,
                    children: t("view.in.map")
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./containers/shopList/shopList.tsx + 5 modules
var shopList = __webpack_require__(20936);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.tsx + 1 modules
var v1 = __webpack_require__(1482);
;// CONCATENATED MODULE: ./components/grocery/grocery-data.ts
// grocery.ts
const groceryData = [
    {
        id: "01",
        titleKey: "grocery.step1.title",
        descriptionKey: "grocery.step1.description"
    },
    {
        id: "02",
        titleKey: "grocery.step2.title",
        descriptionKey: "grocery.step2.description"
    },
    {
        id: "03",
        titleKey: "grocery.step3.title",
        descriptionKey: "grocery.step3.description"
    }
];

// EXTERNAL MODULE: ./components/grocery/grocery.module.scss
var grocery_module = __webpack_require__(79402);
var grocery_module_default = /*#__PURE__*/__webpack_require__.n(grocery_module);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
;// CONCATENATED MODULE: ./components/grocery/grocery.tsx







function Grocery() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (grocery_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (grocery_module_default()).containerTitle,
                children: t("groceries.delivered.on.your.schedule")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (grocery_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    breakpoints: {
                        0: {
                            slidesPerView: 1
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    },
                    children: groceryData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: index === 1 && isDesktop ? (grocery_module_default()).sideBorder : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (grocery_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (grocery_module_default()).number,
                                        children: item.id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (grocery_module_default()).title,
                                        children: t(item.titleKey)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (grocery_module_default()).description,
                                        children: t(item.descriptionKey)
                                    })
                                ]
                            })
                        }, item.id))
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/invite-friend/invite-friend.module.scss
var invite_friend_module = __webpack_require__(90927);
var invite_friend_module_default = /*#__PURE__*/__webpack_require__.n(invite_friend_module);
;// CONCATENATED MODULE: ./components/invite-friend/invite-friend.tsx




function InviteFriend() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (invite_friend_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/referrals",
            className: (invite_friend_module_default()).text,
            children: t("Invite a friend and get money in to your wallet")
        })
    });
}

// EXTERNAL MODULE: ./components/becomeSellerBanner/becomeSellerBanner.module.scss
var becomeSellerBanner_module = __webpack_require__(90729);
var becomeSellerBanner_module_default = /*#__PURE__*/__webpack_require__.n(becomeSellerBanner_module);
;// CONCATENATED MODULE: ./components/becomeSellerBanner/becomeSellerBanner.tsx





function BecomeSellerBanner() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const { push  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (becomeSellerBanner_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (becomeSellerBanner_module_default()).textWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (becomeSellerBanner_module_default()).title,
                        children: t("become.seller.home.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (becomeSellerBanner_module_default()).description,
                        children: t("become.seller.home.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                        fullWidth: false,
                        size: "large",
                        onClick: ()=>push("/be-seller"),
                        children: t("become.seller.home.button")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (becomeSellerBanner_module_default()).imageWrapper
            })
        ]
    });
}

// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(37490);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(21697);
// EXTERNAL MODULE: ./services/recipe.ts
var recipe = __webpack_require__(85685);
// EXTERNAL MODULE: ./components/recipeCard/recipeCard.tsx
var recipeCard = __webpack_require__(46625);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(20835);
// EXTERNAL MODULE: ./containers/recipeList/recipesListSwiper.module.scss
var recipesListSwiper_module = __webpack_require__(60774);
var recipesListSwiper_module_default = /*#__PURE__*/__webpack_require__.n(recipesListSwiper_module);
;// CONCATENATED MODULE: ./containers/recipeList/recipeListSwiper.tsx








function RecipeListSwiper(param) {
    let { title , data , loading =false  } = param;
    if (!loading && !(data === null || data === void 0 ? void 0 : data.length)) {
        return null;
    }
    const renderView = ()=>{
        if (loading) {
            return Array.from(new Array(6)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: (recipesListSwiper_module_default()).swiperSlide,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (recipesListSwiper_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (recipesListSwiper_module_default()).shimmer
                        })
                    })
                }, "recipes_".concat(idx)));
        }
        if (!(data === null || data === void 0 ? void 0 : data.length)) {
            return;
        }
        return data === null || data === void 0 ? void 0 : data.map((item)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: (recipesListSwiper_module_default()).swiperSlide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (recipesListSwiper_module_default()).item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(recipeCard/* default */.Z, {
                        data: item
                    })
                })
            }, item === null || item === void 0 ? void 0 : item.id);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (recipesListSwiper_module_default()).container,
        children: [
            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (recipesListSwiper_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                navigation: true,
                lazy: true,
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Lazy */.oM
                ],
                slidesPerView: "auto",
                className: (recipesListSwiper_module_default()).swiper,
                spaceBetween: 12,
                children: renderView()
            })
        ]
    });
}

// EXTERNAL MODULE: ./constants/features.ts
var features = __webpack_require__(81800);
;// CONCATENATED MODULE: ./containers/homev1/homev1.tsx
























 // ✅ flag ricette
const MobileSearchContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(1030), __webpack_require__.e(7363), __webpack_require__.e(6641)]).then(__webpack_require__.bind(__webpack_require__, 47363)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47363)
            ]
    }
});
const VisitedShops = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2999).then(__webpack_require__.bind(__webpack_require__, 22999)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22999)
            ]
    }
});
function Home() {
    var ref, ref1, ref2;
    const { t , i18n  } = (0,dist_es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 1140px)");
    const locale = i18n.language;
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    const { settings  } = (0,settings_context/* useSettings */.r)();
    const location = (0,useUserLocation/* default */.Z)();
    const [searchModal, handleOpenSearchModal, handleCloseSearchModal] = (0,useModal/* default */.Z)();
    const { data: shopCategoryList , isLoading: shopCategoryLoading  } = (0,es.useQuery)([
        "shopCategory",
        locale
    ], ()=>category/* default.getAllShopCategories */.Z.getAllShopCategories({
            perPage: 20
        }));
    const { data: banners , isLoading: isBannerLoading  } = (0,es.useQuery)([
        "banners",
        locale
    ], ()=>banner/* default.getAll */.Z.getAll());
    const shopParams = {
        category_id: (query === null || query === void 0 ? void 0 : query.category_id) || undefined,
        address: location,
        open: (query === null || query === void 0 ? void 0 : query.open) || undefined,
        column: (query === null || query === void 0 ? void 0 : query.column) || undefined,
        sort: (query === null || query === void 0 ? void 0 : query.sort) || undefined,
        work_24_7: (query === null || query === void 0 ? void 0 : query.work_24_7) || undefined
    };
    const { data , fetchNextPage , hasNextPage , isFetchingNextPage , isLoading  } = (0,es.useInfiniteQuery)([
        "restaurants",
        locale,
        location,
        query === null || query === void 0 ? void 0 : query.column,
        query === null || query === void 0 ? void 0 : query.sort,
        query === null || query === void 0 ? void 0 : query.open,
        query === null || query === void 0 ? void 0 : query.work_24_7,
        query === null || query === void 0 ? void 0 : query.category_id
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.getAll */.Z.getAll(lib_default().stringify({
            page: pageParam,
            perPage: 8,
            ...shopParams
        }));
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        }
    });
    const { data: visitedShops  } = (0,es.useQuery)({
        queryKey: [
            "visitedShops",
            locale,
            isAuthenticated
        ],
        queryFn: ()=>shop/* default.getVisitedShops */.Z.getVisitedShops({
                perPage: 10,
                page: 1
            }),
        staleTime: 0
    });
    const { data: recipes , isLoading: isRecipesLoading  } = (0,es.useQuery)({
        queryKey: [
            "recipes",
            locale,
            shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
        ],
        queryFn: ()=>{
            return recipe/* default.getAll */.Z.getAll({
                perPage: 10,
                category_id: shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
            });
        },
        enabled: features/* default.recipes */.Z.recipes
    });
    const restaurants = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (homev1_module_default()).searchContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (homev1_module_default()).search,
                        onClick: handleOpenSearchModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(t("search.on"), " Gloco")
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).bannerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                        banners: (banners === null || banners === void 0 ? void 0 : banners.data) || [],
                        loadingBanner: isBannerLoading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).homeActionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeActions, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopCategoryListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1["default"], {
                        data: (shopCategoryList === null || shopCategoryList === void 0 ? void 0 : (ref1 = shopCategoryList.data) === null || ref1 === void 0 ? void 0 : ref1.sort((a, b)=>{
                            return (a === null || a === void 0 ? void 0 : a.input) - (b === null || b === void 0 ? void 0 : b.input);
                        })) || [],
                        loading: shopCategoryLoading
                    })
                })
            }),
            !!(visitedShops === null || visitedShops === void 0 ? void 0 : (ref2 = visitedShops.data) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitedShops, {
                        data: visitedShops === null || visitedShops === void 0 ? void 0 : visitedShops.data
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shopList["default"], {
                        title: t("all.shops"),
                        shops: restaurants,
                        loading: isLoading && !isFetchingNextPage,
                        hasNextPage: hasNextPage,
                        fetchNextPage: fetchNextPage,
                        fetchingNextPage: isFetchingNextPage
                    })
                })
            }),
            features/* default.recipes */.Z.recipes && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).recipeListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeListSwiper, {
                        data: recipes === null || recipes === void 0 ? void 0 : recipes.data,
                        loading: isRecipesLoading,
                        title: t("recipes")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).groceryContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grocery, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (homev1_module_default()).inviteFriendContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteFriend, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).becomeSellerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeSellerBanner, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchContainer, {
                open: searchModal,
                onClose: handleCloseSearchModal,
                fullScreen: true
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx



var __N_SSP = true;
function HomePage(param) {
    let {} = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
        ]
    });
}


/***/ }),

/***/ 94910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const bannerService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/".concat(id), {
            params
        }),
    getAllAds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads", {
            params
        }),
    getAdById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (bannerService);


/***/ }),

/***/ 56457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const categoryService = {
    getAllShopCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "shop"
            }
        });
    },
    getAllSubCategories: function(categoryId) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/categories/sub-shop/".concat(categoryId), {
            params
        });
    },
    getAllProductCategories: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/categories"), {
            params
        }),
    getAllRecipeCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "receipt"
            }
        });
    },
    getById: function(id) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/".concat(id), {
            params
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (categoryService);


/***/ }),

/***/ 85685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const recipeService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (recipeService);


/***/ }),

/***/ 1612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    // getAllBooking: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/booking/shops/paginate?${params}`),
    // getAllRestaurants: (params: string): Promise<Paginate<IBookingShop>> =>
    //   request.get(`/rest/shops/paginate?type=restaurant&${params}`),
    // getAllShops: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/shops/paginate?type=shop&${params}`),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 95785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 91893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"bannerSingle_banner__kN2kr","wrapper":"bannerSingle_wrapper__xyQZd"};

/***/ }),

/***/ 90729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"becomeSellerBanner_container___o7cf","textWrapper":"becomeSellerBanner_textWrapper__iLlPa","title":"becomeSellerBanner_title__CpkMA","description":"becomeSellerBanner_description__6UF8q","imageWrapper":"becomeSellerBanner_imageWrapper__Z2E4L"};

/***/ }),

/***/ 8341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"carouselArrows_btn__5gqN5","next":"carouselArrows_next__d5Bj1","prev":"carouselArrows_prev__LrJLV"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"v1_card__vZ8Zq","active":"v1_active___1OE2","img":"v1_img__Pkq7P","text":"v1_text___e43I"};

/***/ }),

/***/ 79402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"grocery_container__NZo1q","containerTitle":"grocery_containerTitle__M7vLB","wrapper":"grocery_wrapper__Ql6QM","swiperSlider":"grocery_swiperSlider__egpZm","item":"grocery_item__VqKrj","number":"grocery_number__M5DyR","title":"grocery_title__31Teo","description":"grocery_description__yagGt","sideBorder":"grocery_sideBorder__5Ee8U"};

/***/ }),

/***/ 44352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"home-actions_container__i_pCP","viewInMap":"home-actions_viewInMap__uk5ey"};

/***/ }),

/***/ 90927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"invite-friend_container__8OcXa","text":"invite-friend_text___CUbx"};

/***/ }),

/***/ 27515:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recipeCard_wrapper__0idu5","header":"recipeCard_header__DFJS8","body":"recipeCard_body__Dy5ek","main":"recipeCard_main__hzXPg","title":"recipeCard_title__R8fph","text":"recipeCard_text__XHWLK","footer":"recipeCard_footer__ykPOn","item":"recipeCard_item__GmQzg","dot":"recipeCard_dot__6bxIP","shopIcon":"recipeCard_shopIcon__wfFlp"};

/***/ }),

/***/ 45286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__ZEunx","banner":"banner_banner__D8D5Q","bannerContainer":"banner_bannerContainer__E7T_G","shimmerContainer":"banner_shimmerContainer__hKSIU","shimmer":"banner_shimmer__tp1rt"};

/***/ }),

/***/ 79457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"homev1_searchContainer__famTe","search":"homev1_search__bYQIC","bannerContainer":"homev1_bannerContainer__K7ekR","homeActionContainer":"homev1_homeActionContainer__yXAfW","shopCategoryListContainer":"homev1_shopCategoryListContainer__HIWQx","shopListContainer":"homev1_shopListContainer__P4ovs","recipeListContainer":"homev1_recipeListContainer__Sl1CH","groceryContainer":"homev1_groceryContainer__po3Ay","inviteFriendContainer":"homev1_inviteFriendContainer__DZcDX","becomeSellerContainer":"homev1_becomeSellerContainer__nn93L"};

/***/ }),

/***/ 60774:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"recipesListSwiper_container__HiwN1","title":"recipesListSwiper_title__JgpPq","swiper":"recipesListSwiper_swiper__2C_3_","swiperSlide":"recipesListSwiper_swiperSlide__cCeO3","item":"recipesListSwiper_item__Y0s41","shimmer":"recipesListSwiper_shimmer__wjbZi"};

/***/ }),

/***/ 12562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"v1_container__4DKRy","title":"v1_title__S4qxw","swiperSlide":"v1_swiperSlide__yiAEb","shimmer":"v1_shimmer__pFUE9","card":"v1_card__dr1_z","active":"v1_active__94rQb","text":"v1_text__aeMs_"};

/***/ }),

/***/ 71350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowLeftSLineIcon = function ArrowLeftSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z' })
  );
};

var ArrowLeftSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowLeftSLineIcon) : ArrowLeftSLineIcon;

module.exports = ArrowLeftSLineIcon$1;


/***/ }),

/***/ 97169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 80578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPinRangeFillIcon = function MapPinRangeFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074zM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' })
  );
};

var MapPinRangeFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPinRangeFillIcon) : MapPinRangeFillIcon;

module.exports = MapPinRangeFillIcon$1;


/***/ }),

/***/ 99954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var RestaurantFillIcon = function RestaurantFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M21 2v20h-2v-8h-3V7a5 5 0 0 1 5-5zM9 13.9V22H7v-8.1A5.002 5.002 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5.002 5.002 0 0 1-4 4.9z' })
  );
};

var RestaurantFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(RestaurantFillIcon) : RestaurantFillIcon;

module.exports = RestaurantFillIcon$1;


/***/ }),

/***/ 11327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var TimeFillIcon = function TimeFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z' })
  );
};

var TimeFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(TimeFillIcon) : TimeFillIcon;

module.exports = TimeFillIcon$1;


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9526,719,9360,2092,936,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);